module.exports = __webpack_public_path__ + "static/systems_seminar2018_Stapleton_materials-61dfa2517bacdddabdc6d4b5384c3e7f.pdf";